
export { default as Table }       from './Table';
export { default as TableHeader } from './tableHeader/TableHeader';
export { default as TableBody }   from './tableBody/TableBody';
export { default as TableRow }    from './tableRow/TableRow';
export { default as TableCol }    from './tableCol/TableCol';



// WEBPACK FOOTER //
// ./src/app/components/table/index.js